// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard-module--card--3-T-o","image":"BlogCard-module--image--2yQGr","footer":"BlogCard-module--footer--RJz31","cardContent":"BlogCard-module--cardContent--3M6RD"};